import React, { useMemo } from 'react';

const UserStats = ({ users }) => {
    const stats = useMemo(() => {
        const total = users.length;
        const admins = users.filter(u => u.role === 'admin').length;
        const clients = users.filter(u => u.role === 'client').length;
        const vendors = users.filter(u => u.role === 'vendor').length;

        // Roughly calculate "new" users as created in the last 30 days
        // Note: Assuming 'created_at' exists on the user object, defaults to date string parsing
        const thirtyDaysAgo = new Date();
        thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);

        const newUsers = users.filter(u => {
            if (!u.created_at) return false;
            const createdDate = new Date(u.created_at);
            return createdDate > thirtyDaysAgo;
        }).length;

        return { total, admins, clients, vendors, newUsers };
    }, [users]);

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
            <div className="bg-white p-4 rounded-lg shadow border border-gray-100 flex items-center justify-between">
                <div>
                    <p className="text-sm font-medium text-gray-500">Total Users</p>
                    <p className="text-2xl font-bold text-gray-900 mt-1">{stats.total}</p>
                </div>
                <div className="p-3 bg-indigo-50 rounded-full">
                    <svg className="w-6 h-6 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                    </svg>
                </div>
            </div>

            <div className="bg-white p-4 rounded-lg shadow border border-gray-100 flex items-center justify-between">
                <div>
                    <p className="text-sm font-medium text-gray-500">Active Clients</p>
                    <p className="text-2xl font-bold text-gray-900 mt-1">{stats.clients}</p>
                </div>
                <div className="p-3 bg-green-50 rounded-full">
                    <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                    </svg>
                </div>
            </div>

            <div className="bg-white p-4 rounded-lg shadow border border-gray-100 flex items-center justify-between">
                <div>
                    <p className="text-sm font-medium text-gray-500">Vendors</p>
                    <p className="text-2xl font-bold text-gray-900 mt-1">{stats.vendors}</p>
                </div>
                <div className="p-3 bg-blue-50 rounded-full">
                    <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                    </svg>
                </div>
            </div>

            <div className="bg-white p-4 rounded-lg shadow border border-gray-100 flex items-center justify-between">
                <div>
                    <p className="text-sm font-medium text-gray-500">System Admins</p>
                    <p className="text-2xl font-bold text-gray-900 mt-1">{stats.admins}</p>
                </div>
                <div className="p-3 bg-red-50 rounded-full">
                    <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                    </svg>
                </div>
            </div>
        </div>
    );
};

export default UserStats;
